<h3 mat-dialog-title class="montserrat-medium mb-4 text-gray-500">Error</h3>
<div mat-dialog-content>
    {{ data.message }}
</div>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-outline-gray-500 mt-4" mat-dialog-close>OK</button>
</div>
